import React from 'react';
import { ErreurServeur } from '../../pages/Erreurs/Erreurs';

interface State {
  hasError: boolean;
}

/**
 * Capture les erreurs de rendu React (toute exception non geree dans l'arbre des routes)
 * et affiche la page 500 Centralis au lieu d'un ecran blanc. Le "Reessayer" tente un
 * remontage soft ; le bouton Accueil recharge l'application.
 */
class ErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    // Best-effort : trace cote client. A brancher sur un service de suivi si besoin.
    console.error('ErrorBoundary a capturé une erreur de rendu', error, info);
  }

  private handleRetry = (): void => this.setState({ hasError: false });

  render(): React.ReactNode {
    if (this.state.hasError) {
      return <ErreurServeur onRetry={this.handleRetry} />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
